import Page from 'react-view/component/page';
import 'normalize.css';
import habo from 'habo';

// 域名映射关系
const DOMAIN_NAME_MAP = {
    'gaotu.cn': 'gt-m',
    'gtgz.cn': 'gt-jingpin-m',
    'gaotu100.com': 'tutu-m',
    'naiyouxuexi.com': 'tutu-gtketang-wap',
    'gtqscz.com': 'tutu-gtketang-wap'
};

// 获取来源域名对应的name
const getSourceName = () => {
    try {
        // 默认返回高途
        if (!document.referrer) return 'gt-m';
        const referrerUrl = new URL(document.referrer);
        const hostname = referrerUrl.hostname;
        
        // 遍历映射关系进行匹配
        for (const [domain, name] of Object.entries(DOMAIN_NAME_MAP)) {
            if (hostname.includes(domain)) {
                return name;
            }
        }
        // 未匹配到时返回默认值
        return 'gt-m';
    } catch (e) {
        console.error('获取来源域名失败:', e);
        return 'gt-m';
    }
};

if (process.title === 'browser') {
    window.Promise = require('promise-polyfill').default;
    if (process.env.NODE_ENV === 'production') {
        const Sentry = require('@sentry/browser');
        const { Integrations } = require('@sentry/tracing');
        Sentry.init({
            dsn: 'https://19a0682ee5db40d59d9c3cb0d4be6f03@sentry.baijia.com/618',
            integrations: [new Integrations.BrowserTracing()],
            // We recommend adjusting this value in production, or using tracesSampler
            // for finer control
            tracesSampleRate: 1.0,
        });
    }
    habo?.setConfig({NAME: getSourceName(), VERB: 'post', ROUTE_MODE: 3, appNid: 'baijia.gt.dev-base.platform-fe.pay-web'});
}
export default Page;
